import { initialState, AppSlice } from './Slice'
import { AppState } from './Type'

export { initialState, AppSlice }
export type { AppState }

export default AppSlice.reducer
